import { UserApi } from "nx-libs";
import { ClientAuthApi, MemberAccountInfoSettingApi } from "@/api";

export const loginESH = async (username, password, lang = null) => {
  try {
    await UserApi.login(
      5,
      {
        Username: username,
        Password: password
      },
      false
    );
  } catch (ex) {
    if (ex.response.data.includes("ERR_AUTH_0008")) { // require E-cert 2FA
      return ex;
    }else{
      throw ex;
    }
  }

  // 4894 redirect to the correct language of the login page after logining
  if (lang) {
    await MemberAccountInfoSettingApi.editLanguage(lang);
  }
};

export const login = async (store, identity) => {
  await store.dispatch("userStore/login", identity);

  return store.getters["userStore/getUserInfo"];
};

export const loginToLanding = async (store, router, identity) => {
  const { username, password } = identity;

  const user = await login(store, {
    identity: {
      Username: username,
      Password: password
    }
  });

  const groupNames = user.groups.map((group) => group.name);
  let route;

  if (groupNames.includes("Professional")) {
    route = { name: "LandingProf" };
  } else if (groupNames.includes("Public")) {
    route = { name: "LandingPublic" };
  } else {
    throw new Error("cannot identity user type");
  }

  router.push(route);
};

export const getPublicPath = () => ({
  ERegistrationProfessionalActivate: "/public/bd/#/registration/prof/activate",
  Login: "/public/bd/#/login"
});

export const redirectToPublicPath = (view) => {
  const href = getPublicPath();

  if (!href[view]) {
    console.warn(`undefined path for position ${pos}`);
    pos = "Login";
  }

  window.location.href = href[view];
};

export const getLandingPathHref = () => ({
  prof: "/bd/ess/#/landing/prof",
  public: "/bd/ess/#/landing/public"
});

export const getLandingPath = (user) => {
  const { groups } = user;
  const landingHref = getLandingPathHref();

  const groupNames = groups.map((group) => group.name);

  if (groupNames.includes("Professional")) {
    return landingHref.prof;
  }

  return landingHref.public;
};

export const redirectToLanding = (pos) => {
  const href = getLandingPathHref();

  if (!href[pos]) {
    console.warn(`undefined path for position ${pos}`);
    pos = "public";
  }

  window.location.href = href[pos];
};

export const redirectToLandingByUser = (user) => {
  const href = getLandingPath(user);

  window.location.href = href;
};

export const getUserPosition = (user) => {
  const { groups } = user;

  if (!groups) {
    return "Registered User";
  }

  const posMap = getPositions();
  const groupNames = groups.map((group) => group.name);

  return (
    posMap.get(groupNames.find((name) => posMap.has(name))) || "Registered User"
  );
};

export const getPositions = () => {
  const map = new Map();

  map.set("AP", "Authorized Person (AP)");
  map.set("RSE", "Registered Structural Engineer (RSE)");
  map.set("RGE", "Registered Geotechnical Engineer (RGE)");
  map.set("RI", "Registered Inspectors (RI)");
  map.set("QP", "Qualified Persons (QP)");

  return map;
};
